class SDC_Lazyload {
	constructor(selector, callback) {
		this.callback = callback;
		this.selector = selector;
		this.init();
	}

	// Get Nodes Array
	get elements() {
		return [].slice.call(document.querySelectorAll(this.selector));
	}

	// Init
	init() {
		this.instanceObserver();
	}

	// Instance IntersectionObserver
	instanceObserver() {
		// this.callback = this.callback.bind(this);
		if ("IntersectionObserver" in window) {
			let IntersectionObserver = window.IntersectionObserver ||
				window.WebKitIntersectionObserver ||
				window.MozIntersectionObserver;
			// Instance
			let observer = new IntersectionObserver((entries, observer) => {
				// Fire Callback Method
				this.observerCallback(entries, observer);
			});
			this.elements.forEach(function (video) {
				observer.observe(video);
			});
		}
	}

	// Callback function
	observerCallback(entries, observer) {
		entries.forEach((entry) => {

			// Check for element in the viewport
			if (entry.isIntersecting) {
				// Callback Function
				this.lazyload(entry);
				// Stop
				observer.unobserve(entry.target);
			}

		});
	}

	lazyload( entry ) {
		let item = entry.target; // Get item

		if (typeof item.tagName === "string" && ( item.tagName === "VIDEO" || item.tagName === "IMG" ) ) {
			item.src = item.dataset.src; // Set src attribute from data-src attribute
		}

		if ( item.tagName === "VIDEO" ) {
			item.load(); // Load Video
		}
		
		item.classList.remove("lazy"); // Remove class "lazy"
	}
}


document.addEventListener("DOMContentLoaded", () => {
	// Instance Class IntersObserver
	new SDC_Lazyload('.lazy')
})
